import './GrafoInfoCard.scss'
import { Box, Card, CardContent, IconButton } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

interface IGrafoInfoCard {
  data: any
  setIsModalOpen: React.Dispatch<React.SetStateAction<boolean>>
}

type DataToShow = {
  nombre: string
  id: string //Número de identificación:
  tipo: string
  pais: string
  perfil: string
  city: string
  state: string
  municipality: string
  bioma_or_region: string
  lithium_type: string
  clickedType: string
  companies: string[]
}

const getLang = (language: string) => {
  if (language.includes('es')) {
    return 'spanish'
  } else if (language.includes('en')) {
    return 'english'
  } else if (language.includes('pt')) {
    return 'portuguese'
  }
}
export const GrafoInfoCard = ({ data, setIsModalOpen }: IGrafoInfoCard) => {
  const { t, i18n }: any = useTranslation()
  const language = getLang(i18n.language)
  const [dataToShow, setDataToShow] = useState<Partial<DataToShow>>()

  const handleCardClose = () => {
    setIsModalOpen(false)
  }

  useEffect(() => {
    if (data) {
      const preData: Partial<DataToShow> = {}

      if ('shareholder_intern_id' in data) {
        Object.assign(preData, {
          nombre: data.shareholder_name,
          id: data.shareholder_intern_id,
          companies: data.companies_name_share_percentage,
          clickedType: 'socio',
        })
      } else if ('company_type' in data) {
        Object.assign(preData, {
          nombre: data.company_name,
          id: data.company_id,
          tipo: t(`empresa.tipo.${data.company_type}`),
          pais: t(`countries.${data.company_country}`),
          perfil: data[`${language}_profile`] || t('no_disponible'),
          city: data.city,
          state: data.state,
          clickedType: 'empresa',
        })
      } else if ('project_intern_id' in data) {
        Object.assign(preData, {
          nombre: data.property_name_or_project_name,
          state: data.state_or_province_or_region_or_department.join(' / '),
          municipality: data.municipality.join(' / '),
          bioma_or_region: data.bioma_or_region.join(' / '),
          lithium_type: data.lithium_type,
          clickedType: 'proyecto',
          pais: t(`countries.${data.country}`),
        })
      }

      setDataToShow(preData)
    }
  }, [data, language])

  const getCardContent = () => {
    switch (dataToShow?.clickedType) {
      case 'socio':
        return (
          <ul className="infoCard_data">
            <li>
              <span className="infoCard_data_title">{dataToShow.nombre}</span>
            </li>
            <li>
              <strong>{t('persona.shares_percentages')}: </strong>
              {dataToShow.companies?.length ? (
                <ul>
                  {dataToShow.companies.map((company, index) => (
                    <li key={index}>{company}</li>
                  ))}
                </ul>
              ) : null}
            </li>
          </ul>
        )

      case 'empresa':
        return (
          <ul className="infoCard_data">
            <li>
              <span className="infoCard_data_title">{dataToShow.nombre}</span>
            </li>
            <li>
              <strong>{t('numero_id')}: </strong>
              <span>{dataToShow.id}</span>
            </li>
            <li>
              <strong>{t('empresa.tipo_entidad')}: </strong>
              <span>{dataToShow.tipo}</span>
            </li>

            <li>
              <strong>{t('project.country')}: </strong>
              <span>{dataToShow.pais}</span>
            </li>
            <li>
              <strong>{t('empresa.state')}: </strong>
              <span>{dataToShow.state}</span>
            </li>
            <li>
              <strong>{t('empresa.city')}: </strong>
              <span>{dataToShow.city}</span>
            </li>
            {dataToShow.perfil && (
              <li className="infoCard_data_perfil">
                <strong>{t('empresa.perfil')}: </strong>
                <span>{dataToShow.perfil}</span>
              </li>
            )}
          </ul>
        )
      case 'proyecto':
        return (
          <ul className="infoCard_data">
            <li>
              <span className="infoCard_data_title">{dataToShow.nombre}</span>
            </li>
            <li>
              <strong>{t('project.country')}: </strong>
              <span>{dataToShow.pais}</span>
            </li>
            <li>
              <strong>{t('project.departament')}: </strong>
              <span>{dataToShow.state}</span>
            </li>
            <li>
              <strong>{t('project.municipality')}: </strong>
              <span>{dataToShow.municipality}</span>
            </li>
            <li>
              <strong>{t('project.bioma_region')}: </strong>
              <span>{t(`biomas.${dataToShow.bioma_or_region}`)}</span>
            </li>
            <li>
              <strong>{t('project.deposit_type')}: </strong>
              <span>{t(`lithium_types.${dataToShow.lithium_type}`)}</span>
            </li>

            {/* <li>
              <strong>{t('project.territory')}: </strong>
              <span>{dataToShow.territorio}</span>
            </li>
            <li>
              <strong>{t('project.project_period')}: </strong>
              <span>{dataToShow.periodo}</span>
            </li>
            <li>
              <strong>{t('project.auditor')}: </strong>
              <span>{dataToShow.auditor}</span>
            </li>
            <li>
              <strong>{t('project.certifier')}: </strong>
              <span>{dataToShow.certificadora}</span>
            </li> */}
          </ul>
        )
    }

    return
  }

  return (
    <Box sx={{ position: 'absolute', top: 65, right: 23, width: '300px' }}>
      <Card>
        <CardContent sx={{ position: 'relative', padding: '0 !important' }}>
          <>
            <IconButton
              style={{ position: 'absolute', right: 10, top: 0 }}
              aria-label="settings"
              onClick={handleCardClose}
            >
              <CloseIcon />
            </IconButton>
            {getCardContent()}
          </>
        </CardContent>
      </Card>
    </Box>
  )
}
